import { TariffsRoutes as TariffsRoutesEnum } from '../routes';
import Tariffs from '../hoc/tariffs/tariffs';
import TariffsList from '../hoc/tariffs/list';
import CreateTariffItemForm from '../hoc/tariffs/create-tariff';
import TariffPage from '../hoc/tariffs/tariff-page';
import FeeForm from '../hoc/tariffs/fee-form';

const TariffsRoutes = {
  path: TariffsRoutesEnum.TARIFFS,
  element: <Tariffs />,
  children: [
    {
      path: TariffsRoutesEnum.TARIFFS_LIST,
      element: <TariffsList />,
      children: [
        {
          path: TariffsRoutesEnum.TARIFFS_CREATE_TARIFF,
          element: <CreateTariffItemForm />,
        },
      ],
    },
    {
      path: TariffsRoutesEnum.TARIFFS_INFO,
      element: <TariffPage />,
      children: [
        {
          path: TariffsRoutesEnum.TARIFFS_INFO_ADD_FEE,
          element: <FeeForm />,
        },
        {
          path: TariffsRoutesEnum.TARIFFS_INFO_FEE,
          element: <FeeForm />,
        },
      ],
    },
  ],
};

export default TariffsRoutes;
